import { networkApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const networkApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getNetworkProviders: builder.query({
      query: () => ({
        url: networkApi(),
        method: 'POST',
        body: {
          data: {},
          method: 'getNetworkProviders'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['NetworkProviders'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetNetworkProvidersQuery,
} = networkApiSlice;
